import { Award, Sparkles, Handshake, Compass } from "lucide-react";
const pillars = [{
  title: "20+ Years Experience",
  description: "Decades of combined expertise providing secure and sophisticated financial pathways for our clients.",
  icon: Award,
  bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/finance_pattern_1.png"
}, {
  title: "Personalised Strategy",
  description: "Bespoke lending structures tailored specifically to align with your unique wealth goals and lifestyle.",
  icon: Compass,
  bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/finance_pattern_2.png"
}, {
  title: "Transparent Advice",
  description: "Honest, clear communication with no hidden agendas—just straightforward, expert financial guidance.",
  icon: Sparkles,
  bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/finance_pattern_3.png"
}, {
  title: "Long-Term Support",
  description: "Our dedicated partnership extends far beyond settlement, ensuring your finance continues to perform.",
  icon: Handshake,
  bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/finance_pattern_4.png"
}];
export default function BrandExcellencePillars() {
  return <section data-section-id="222543" id="the-strategic-advantage" className="bg-background text-foreground w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full">
        {pillars.map((pillar, i) => {
        const Icon = pillar.icon;
        return <div key={i} data-index={i} className="group relative overflow-hidden min-h-[320px] flex flex-col items-center justify-center p-8 text-center cursor-default">
              {}
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out group-hover:scale-110" style={{
            backgroundImage: `url(${pillar.bgImage})`
          }} />
              
              {}
              <div className="absolute inset-0 bg-white/60 backdrop-blur-md transition-colors duration-500 group-hover:bg-white/40" />

              {}
              <div className="relative z-10 flex flex-col items-center gap-5 max-w-[280px]">
                <Icon className="w-10 h-10 text-secondary transition-all duration-500 group-hover:text-primary group-hover:scale-110" />
                <h3 className="text-2xl font-default font-bold text-primary tracking-tight">
                  {pillar.title}
                </h3>
                <p className="text-sm font-default text-secondary leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            </div>;
      })}
      </div>
    </section>;
}